import { useParams, useLocation } from "react-router-dom";
import { useJobRoutes } from "../../Component/Hooks/RoutesDynamic/RoutesDynamic";
import JobContainer from "./JobPageComponent/JobPageComponent";
import JobContainerAr from "./JobPageComponent/JobPageComponentAr";
import { LoaderWrap } from "../../Component/GlobalLoader/LoaderWrap";
import GlobalLoader from "../../Component/GlobalLoader/GlobalLoader";

export default function JobsPage() {
  const { jobId } = useParams();
  const location = useLocation();
  const isArabic = location.pathname.includes("/ar");
  const { jobs, loading, error } = useJobRoutes();
  const job = jobs.find((p) => p.jobId === jobId);

  // Debugging to check career slice state
  console.log("Career Slice - Jobs:", jobs, "Loading:", loading, "Error:", error);

  if (loading) {
    return (
      <LoaderWrap>
        <GlobalLoader />
      </LoaderWrap>
    );
  }

  if (error) {
    return (
      <LoaderWrap>
        <div>Error: {error}</div>
      </LoaderWrap>
    );
  }

  if (!job) {
    return (
      <LoaderWrap>
        <div>Job not found</div>
      </LoaderWrap>
    );
  }

  const hasArabicData = job.JobH1Data && job.JobH2Data?.length > 0 && job.JobH4Data?.length > 0;
  const Component = isArabic ? JobContainerAr : JobContainer;

  // Debugging to ensure the correct lang is detected
  console.log("URL:", location.pathname, "isArabic:", isArabic, "hasArabicData:", hasArabicData);

  return (
    <LoaderWrap>
      <Component JobData={[job]} />
    </LoaderWrap>
  );
}
